import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DialogConfirmation } from '../../../../../../components/dialog/confirmation';
import { useInstallationContext } from '../../../../../../context/installation';
import { ROUTES } from '../../../../../../routes/routes';
import * as storage from '../../../../storage';

type UpdateDevicesDialogProps = {
  showDialog: boolean;
  setShowDialog: (show: boolean) => void;
};

export const UpdateDevicesDialog: React.FC<UpdateDevicesDialogProps> = ({ showDialog, setShowDialog }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('device-list');
  const { t: tc } = useTranslation('common');
  const { selectedInstallationId } = useInstallationContext();

  const handleClose = () => {
    if (selectedInstallationId) {
      let updateDevicesMemory = storage.getItem('updateDevicesMemory');

      if (updateDevicesMemory) {
        if (selectedInstallationId in updateDevicesMemory) {
          updateDevicesMemory[selectedInstallationId] = new Date();
        } else updateDevicesMemory = { ...updateDevicesMemory, [selectedInstallationId]: new Date() };
      } else updateDevicesMemory = { [selectedInstallationId]: new Date() };

      storage.setItem('updateDevicesMemory', updateDevicesMemory);
    }
    setShowDialog(false);
  };

  const handleAction = () => {
    handleClose();
    navigate(ROUTES.Device());
  };

  return (
    <DialogConfirmation
      show={showDialog}
      setShow={handleClose}
      header={t('updateDevicesInfo.header')}
      content={t('updateDevicesInfo.content')}
      primaryBtnText={tc('buttons.continue')}
      secondaryBtnText={tc('buttons.cancel')}
      primaryBtnAction={handleAction}
      secondaryBtnAction={handleClose}
    />
  );
};
